module.exports = " <div class=vc-page> <header-bar> <icon-button slot=left @click=back() icon=arrow_back></icon-button> <span>Float Button</span> </header-bar> <scroll-view> <content-block class=demo-float-button> <float-button icon=delete_forever color=carbon></float-button> <float-button icon=mode_edit></float-button> <float-button icon=search color=green></float-button> <float-button icon=star color=amber></float-button> <float-button icon=filter_drama color=blue></float-button> <float-button fixed></float-button> </content-block> </scroll-view> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src-examples/views/floatButton.vue
 ** module id = 391
 ** module chunks = 1
 **/